'use strict';

angular
  .module('myConsultApp')
  .factory(
    'AuthService',
    function ($resource, ENV, Session, $location, redirectToUrlAfterLogin, utilities) {
      var authService = {};

      authService.login = function (credentials) {
        // For login ATLAS is expecting post params instead of object, that's why we override the save method
        var user = $resource(
          ENV.tokenApiEndpoint + '/o/token/',
          {},
          {
            save: {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
              transformRequest: function (data, headersGetter) {
                return angular.isObject(data) && String(data) !== '[object File]'
                  ? jQuery.param(data)
                  : data;
              },
              ignoreAuthModule: true,
            },
          },
        );

        return user.save(credentials).$promise.then(function (response) {
          return response;
        });
      };

      authService.refreshToken = function (credentials) {
        // For login ATLAS is expecting post params instead of object, that's why we override the save method
        var user = $resource(
          ENV.tokenApiEndpoint + '/o/token/',
          {},
          {
            save: {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
              transformRequest: function (data, headersGetter) {
                return angular.isObject(data) && String(data) !== '[object File]'
                  ? jQuery.param(data)
                  : data;
              },
              ignoreAuthModule: true,
            },
          },
        );

        return user.save(credentials).$promise.then(function (response) {
          return response;
        });
      };

      authService.isAuthenticated = function () {
        return !!Session.userId;
      };

      authService.isAuthorized = function (authorizedRoles) {
        if (!angular.isArray(authorizedRoles)) {
          authorizedRoles = [authorizedRoles];
        }
        return authService.isAuthenticated() && authorizedRoles.indexOf(Session.userRole) !== -1;
      };

      authService.saveAttemptUrl = function () {
        var ignorePaths = ['/login'];

        if (!ignorePaths.contains($location.path().toLowerCase())) {
          redirectToUrlAfterLogin.url = $location.path();
        } else {
          redirectToUrlAfterLogin.url = '/';
        }
      };

      return authService;
    },
  );
